export function fetchSaveEvent() {
    window.onkeydown = function (event) {
        // fetch save command mac
        if (event.which === 83 && event.metaKey || event.which === 83 && event.ctrlKey) {
            event.preventDefault();
            return false;
        }
    }
}
